// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    deepOrange
} from '@mui/material/colors';
import Box from "@mui/material/Box";
import {DataGridPro,GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";

// App Imports
import {getContractHeaderStandard} from "../../Contract/ContractClient";
import {getOwedHierarchy} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {changeOwed} from "./owedSlice";
import {changeRowSelect} from "../../Menus/rowSelectSlice";
import {updateCdpStatus, updateCdpStatusByContract} from "../../ContractDataPoint/ContractDataPointClient";
import LinearIndeterminate from "../../CommonComponents/Progress";
import {WorkIssuanceOwedGridColumns} from "./WorkIssuanceOwedGridColumns";
import {changeWorkIssuance} from "../workIssuanceSlice";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import useWorkIssuanceGridControls from "../Status/useWorkIssuanceGridControls";


// main function
export default function WorkIssuanceOwedGrid() {


    // ****************** BEGIN STATES ****************************

    const [contracts, setContracts] = useState([]);
    const [selectedCdps, setSelectedCdps] = React.useState([]);
    const [selectedContractIds, setSelectedContractIds] = React.useState([]);
    const [selectedVersionNumber, setSelectedVersionNumber] = React.useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [contractHeader, setContractHeader] = React.useState([]);
    const [selectorContractName, setSelectorContractName] = React.useState([]);
    const [selectorContractHeader, setSelectorContractHeader] = React.useState([]);

    // ****************** END STATES ****************************

    // *********************** BEGIN STORE ********************************

    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const selectorProductId = useSelector((state) => state.workIssuanceSlc.value.fetchProductId);

    const selectorOwedGridRefresh = useSelector(
        state => state.workIssuanceSlc.value.owedGridRefresh
    );

    const cashState = useSelector((state) => state.workIssuanceSlc.value.cashState);

    const accrualState = useSelector((state) => state.workIssuanceSlc.value.accrualState);
    const liabilityState = useSelector((state) => state.workIssuanceSlc.value.liabilityState);
    const ultimatesState = useSelector((state) => state.workIssuanceSlc.value.ultimatesState);
    const fetchProductId = useSelector((state) => state.workIssuanceSlc.value.fetchProductId);
    const fetchVersionNumber = useSelector((state) => state.workIssuanceSlc.value.fetchVersionNumber);

    const approvedState = useSelector((state) => state.owedSlc.value.approvedState);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    const hideActions = localStorage.getItem('hideActions') === "true";

    const {
        handleApprove,
        // handleReject,
        // handleDefer,
        // handleHold,
        // handleFlag,
        // handleUnapprove,
        // handlePaid,
        // handleIssued,
        handleMousedRow
    } = useWorkIssuanceGridControls({
        contracts,

        selectedCdps,
        setSelectedCdps,

        selectedContractIds,
        setSelectedContractIds,

        selectedVersionNumber,
        setSelectedVersionNumber,

        setSubmitting,

        changeGridState: changeOwed
    });


    // ****************** BEGIN FETCH ****************************

    const fetchContractHeaders = () => {
        if (selectorContractId > 0
        ) {
            getContractHeaderStandard(selectorContractId)

                .then(data => {
                    console.log("My header");
                    console.log(data);
                    setContractHeader(data);
                    setSelectorContractName(data[0].name);
                    setSelectorContractHeader(data[0]);
                })}};


    const fetchOwed = () => {
        if (fetchProductId > 0
        ){
            console.log("cashState = ", cashState);
            console.log("accrualState = ", accrualState);
            console.log("liabilityState = ", liabilityState);
            console.log("ultimatesState = ", ultimatesState);
            let calcType = null;

            if (cashState === true) {
                calcType = "Current Amount Owed";
            }
            else if (accrualState === true) {
                calcType = "Accrual Current Amount Owed";
            }
            else if (liabilityState === true) {
                calcType = "Liability Current Amount Owed";
            }
            else if (ultimatesState === true) {
                calcType = "Ultimate Current Amount Owed";
            }
            setSubmitting(true);
                // getOwedHierarchy(fetchProductId, calcType)
            getOwedHierarchy(fetchProductId, fetchVersionNumber, calcType)

                    .then(data => {
                        console.log(data);
                        setContracts(data);
                    })
                    .finally(()=>{setSubmitting(false);});
            }};

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        console.log("Loading Contracts Header");
        fetchContractHeaders()
    }, []);
    //
    //
    // useEffect(() => {
    //     console.log("Loading the contract grid...");
    //     fetchOwed();
    // }, []);


    // useEffect(() => {
    //     console.log("owed fetch triggered by grid refresh = true");
    //     console.log("selectorProductId = ", selectorProductId);
    //     fetchOwed();
    //     dispatchData(changeWorkIssuance({owedGridRefresh: false}));
    // }, [useSelector((state) => state.workIssuanceSlc.value.owedGridRefresh)===true]);

    useEffect(() => {
        if (selectorOwedGridRefresh === true && fetchProductId > 0 && fetchVersionNumber > 0) {
            console.log("owed fetch triggered");
            console.log("fetchProductId =", fetchProductId);
            console.log("fetchVersionNumber =", fetchVersionNumber);

            fetchOwed();

            dispatchData(changeWorkIssuance({ owedGridRefresh: false }));
        }
    }, [selectorOwedGridRefresh, fetchProductId, fetchVersionNumber]);

    useEffect(() => {
        setContracts([]);
        dispatchData(changeWorkIssuance({clearData: false}));
    }, [useSelector((state) => state.workIssuanceSlc.value.clearData)===true]);


    useEffect(() => {
        console.log("owed status change triggered by use state");
        handleApprove();
        dispatchData(changeOwed({approvedState: false}));
    }, [useSelector((state) => state.owedSlc.value.approvedState)===true]);

    //
    // useEffect(() => {
    //     // setSubmitting(true);
    //     console.log("owed status change triggered by use state");
    //     dispatchData(changeOwed({rejectedState: false}));
    //     handleReject();
    // }, [useSelector((state) => state.owedSlc.value.rejectedState)===true]);
    //
    //
    // useEffect(() => {
    //     // setSubmitting(true);
    //     console.log("owed status change triggered by use state");
    //     dispatchData(changeOwed({deferState: false}));
    //     handleDefer();
    // }, [useSelector((state) => state.owedSlc.value.deferState)===true]);
    //
    //
    // useEffect(() => {
    //     console.log("owed status change triggered by use state");
    //     dispatchData(changeOwed({holdState: false}));
    //     handleHold();
    // }, [useSelector((state) => state.owedSlc.value.holdState)===true]);
    //
    //
    // useEffect(() => {
    //     // setSubmitting(true);
    //     console.log("owed status change triggered by use state");
    //     dispatchData(changeOwed({flagState: false}));
    //     handleFlag();
    // }, [useSelector((state) => state.owedSlc.value.flagState)===true]);
    //
    //
    // useEffect(() => {
    //     console.log("owed status change triggered by use state");
    //     dispatchData(changeOwed({unapproveState: false}));
    //     handleUnapprove();
    // }, [useSelector((state) => state.owedSlc.value.unapproveState)===true]);
    //
    //
    // useEffect(() => {
    //     console.log("owed status change triggered by use state");
    //     dispatchData(changeOwed({paidState: false}));
    //     handlePaid();
    // }, [useSelector((state) => state.owedSlc.value.paidState)===true]);
    //
    //
    // useEffect(() => {
    //     console.log("owed status change triggered by use state");
    //     dispatchData(changeOwed({issuedState: false}));
    //     handleIssued();
    // }, [useSelector((state) => state.owedSlc.value.issuedState)===true]);

    // ******************** END USE EFFECTS *******************

    //
    // // ***************** BEGIN CONTROLS ***************************
    //
    // const handleApprove = () => {
    //     if (selectedCdps.length > 0 && approvedState === true) {
    //         dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "info", crudMessage: "Approval initiated"}));
    //         setSubmitting(true);
    //         console.log("approved cdp.....");
    //         console.log(JSON.stringify(selectedCdps.map((id, index) => parseInt(id))).slice(1, -1));
    //         console.log("approved contracts.....");
    //         console.log(JSON.stringify(selectedContractIds.map((id, index) => parseInt(id))).slice(1, -1));
    //         console.log("approved version.....");
    //         console.log(JSON.stringify(selectedVersionNumber.map((id, index) => parseInt(id))).slice(1, -1));
    //         updateCdpStatusByContract("2039", JSON.stringify(selectedContractIds.map((id, index) => parseInt(id))).slice(1, -1),
    //             JSON.stringify(selectedVersionNumber.map((id, index) => parseInt(id))).slice(1, -1))
    //             .then(() => {
    //                 // dispatchData(changeOwed({approvedState: false, refreshOwedGrid: true}));
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "success",
    //                     crudMessage: "Records approved"
    //                 }));
    //             })
    //             .catch(err => {
    //                 console.log(err)
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "error",
    //                     crudMessage: "Approval failed"
    //                 }));
    //             })
    //             .finally(() => {
    //                 setSubmitting(false);
    //                 dispatchData(changeOwed({approvedState: false, owedNewStatus: null}));
    //                 dispatchData(changeWorkIssuance({owedGridRefresh: true}));
    //             });
    //     }
    // };
    //
    //
    // const handleReject = () => {
    //     if (selectedCdps.length > 0) {
    //         setSubmitting(true);
    //         updateCdpStatus("2042", JSON.stringify(selectedCdps.map((id, index) => parseInt(id))).slice(1, -1))
    //             .then(() => {
    //                 dispatchData(changeOwed({rejectedState: false}));
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "success",
    //                     crudMessage: "Records rejected"
    //                 }));
    //             })
    //             .catch(err => {
    //                 console.log(err)
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "error",
    //                     crudMessage: "Rejection failed"
    //                 }));
    //             })
    //             .finally(() => {
    //                 setSubmitting(false);
    //                 // dispatchData(changeOwed({rejectedState: false, owedNewStatus: null}));
    //                 dispatchData(changeOwed({rejectedState: false, owedNewStatus: null}));
    //                 dispatchData(changeWorkIssuance({owedGridRefresh: true}));
    //             });
    //     }
    // };
    //
    //
    // const handleDefer = () => {
    //     if (selectedCdps.length > 0) {
    //         setSubmitting(true);
    //         updateCdpStatus("2043", JSON.stringify(selectedCdps.map((id, index) => parseInt(id))).slice(1, -1))
    //             .then(() => {
    //                 dispatchData(changeOwed({deferState: false}));
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "success",
    //                     crudMessage: "Records deferred"
    //                 }));
    //             })
    //             .catch(err => {
    //                 console.log(err)
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "error",
    //                     crudMessage: "Deferral failed"
    //                 }));
    //             })
    //             .finally(() => {
    //                 setSubmitting(false);
    //                 // dispatchData(changeOwed({deferState: false, owedNewStatus: null}));
    //                 dispatchData(changeOwed({rejectedState: false, owedNewStatus: null}));
    //                 dispatchData(changeWorkIssuance({owedGridRefresh: true}));
    //             });
    //     }
    // };
    //
    //
    // const handleHold = () => {
    //     if (selectedCdps.length > 0) {
    //         setSubmitting(true);
    //         updateCdpStatus("2041", JSON.stringify(selectedCdps.map((id, index) => parseInt(id))).slice(1, -1))
    //             .then(() => {
    //                 dispatchData(changeOwed({holdState: false}));
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "success",
    //                     crudMessage: "Records put on hold"
    //                 }));
    //             })
    //             .catch(err => {
    //                 console.log(err)
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "error",
    //                     crudMessage: "Hold failed"
    //                 }));
    //             })
    //             .finally(() => {
    //                 setSubmitting(false);
    //                 // dispatchData(changeOwed({holdState: false, owedNewStatus: null}));
    //                 dispatchData(changeOwed({holdState: false, owedNewStatus: null}));
    //                 dispatchData(changeWorkIssuance({owedGridRefresh: true}));
    //             });
    //     }
    // };
    //
    //
    // const handleFlag = () => {
    //     if (selectedCdps.length > 0) {
    //         setSubmitting(true);
    //         updateCdpStatus("2602", JSON.stringify(selectedCdps.map((id, index) => parseInt(id))).slice(1, -1))
    //             .then(() => {
    //                 dispatchData(changeOwed({flagState: false}));
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "success",
    //                     crudMessage: "Records flagged"
    //                 }));
    //             })
    //             .catch(err => {
    //                 console.log(err)
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "error",
    //                     crudMessage: "Flagging failed"
    //                 }));
    //             })
    //             .finally(() => {
    //                 setSubmitting(false);
    //                 // dispatchData(changeOwed({flagState: false, owedNewStatus: null}));
    //                 dispatchData(changeOwed({flagState: false, owedNewStatus: null}));
    //                 dispatchData(changeWorkIssuance({owedGridRefresh: true}));
    //             });
    //     }
    // };
    //
    //
    // const handleUnapprove = () => {
    //     if (selectedCdps.length > 0) {
    //         setSubmitting(true);
    //         updateCdpStatus("2040", JSON.stringify(selectedCdps.map((id, index) => parseInt(id))).slice(1, -1))
    //             .then(() => {
    //                 dispatchData(changeOwed({unapproveState: false}));
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "success",
    //                     crudMessage: "Records unapproved"
    //                 }));
    //             })
    //             .catch(err => {
    //                 console.log(err)
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "error",
    //                     crudMessage: "Unapproval failed"
    //                 }));
    //             })
    //             .finally(() => {
    //                 setSubmitting(false);
    //                 // dispatchData(changeOwed({unapproveState: false, owedNewStatus: null}));
    //                 dispatchData(changeOwed({unapproveState: false, owedNewStatus: null}));
    //                 dispatchData(changeWorkIssuance({owedGridRefresh: true}));
    //             });
    //     }
    // };
    //
    // const handlePaid = () => {
    //     if (selectedCdps.length > 0) {
    //         setSubmitting(true);
    //         updateCdpStatus("2351", JSON.stringify(selectedCdps.map((id, index) => parseInt(id))).slice(1, -1))
    //             .then(() => {
    //                 dispatchData(changeOwed({paidState: false}));
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "success",
    //                     crudMessage: "Records marked as paid"
    //                 }));
    //             })
    //             .catch(err => {
    //                 console.log(err)
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "error",
    //                     crudMessage: "Paid update failed"
    //                 }));
    //             })
    //             .finally(() => {
    //                 setSubmitting(false);
    //                 // dispatchData(changeOwed({paidState: false, owedNewStatus: null}));
    //                 dispatchData(changeOwed({paidState: false, owedNewStatus: null}));
    //                 dispatchData(changeWorkIssuance({owedGridRefresh: true}));
    //             });
    //     }
    // };
    //
    // const handleIssued = () => {
    //     if (selectedCdps.length > 0) {
    //         setSubmitting(true);
    //         updateCdpStatus("3242", JSON.stringify(selectedCdps.map((id, index) => parseInt(id))).slice(1, -1))
    //             .then(() => {
    //                 dispatchData(changeOwed({issuedState: false}));
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "success",
    //                     crudMessage: "Records marked as issued"
    //                 }));
    //             })
    //             .catch(err => {
    //                 console.log(err)
    //                 dispatchData(changeCrudSnackbar({
    //                     crudOpen: true,
    //                     crudSeverity: "error",
    //                     crudMessage: "Issued update failed"
    //                 }));
    //             })
    //             .finally(() => {
    //                 setSubmitting(false);
    //                 // dispatchData(changeOwed({paidState: false, owedNewStatus: null}));
    //                 dispatchData(changeOwed({issuedState: false, owedNewStatus: null}));
    //                 dispatchData(changeWorkIssuance({owedGridRefresh: true}));
    //             });
    //     }
    // };
    //
    //
    // function handleMousedRow(data) {
    //     console.log("hierarchy for row");
    //     console.log(data.hierarchy);
    //     setSelectedCdps(contracts.filter(contracts => contracts.hierarchy.indexOf(data.hierarchy)  > -1
    //         && contracts.cdpId !== null)
    //         .map((item) => {
    //             return `${item.cdpId}`;
    //         }));
    //     setSelectedContractIds(contracts.filter(contracts => contracts.hierarchy.indexOf(data.hierarchy)  > -1
    //         && contracts.cdpId !== null)
    //         .map((item) => {
    //             return `${item.contractId}`;
    //         }));
    //     console.log("matching records");
    //     console.log(contracts.filter(contracts => contracts.hierarchy.indexOf(data.hierarchy)  > -1
    //     && contracts.cdpId !== null)
    //         .map((item) => {
    //             return `${item.cdpId}`;
    //         }));
    //     console.log("moused contracts");
    //     console.log(contracts.filter(contracts => contracts.hierarchy.indexOf(data.hierarchy)  > -1
    //         && contracts.cdpId !== null)
    //         .map((item) => {
    //             return `${item.contractId}`;
    //         }));
    //     const contractIds = [
    //         ...new Set(
    //             contracts
    //                 .filter(c => c.hierarchy.includes(data.hierarchy) && c.cdpId !== null)
    //                 .map(c => c.contractId)          // keep as number/string—no template literal needed
    //         )
    //     ];
    //     console.log("here are my unique moused contract ids")
    //     console.log(contractIds);   // → [101, 205, 412, …] — each contractID appears only once
    //     setSelectedContractIds(contractIds)
    //     const versionNumber = [
    //         ...new Set(
    //             contracts
    //                 .filter(c => c.hierarchy.includes(data.hierarchy) && c.cdpId !== null)
    //                 .map(c => c.versionNumber)          // keep as number/string—no template literal needed
    //         )
    //     ];
    //     console.log("here are my unique moused version number")
    //     console.log(versionNumber);   // → [101, 205, 412, …] — each contractID appears only once
    //     setSelectedVersionNumber(versionNumber)
    //     console.log('moused row');
    //     console.log(data);
    //     dispatchData(changeRowSelect({contractId: data.contractId, contractSectionId: data.contractSectionId,
    //     cdpId: data.cdpId, cdpvId: data.cdpvId, cdpvfId: null, csfId: null, status: data.status,
    //     cdpList: contracts.filter(contracts => contracts.hierarchy.indexOf(data.hierarchy)  > -1
    //         && contracts.cdpId !== null)
    //         .map((item) => {
    //             return `${item.cdpId}`;
    //         })}));
    //     console.log("cdp id");
    // }
    //
    // // *************** END CONTROLS *******************************
    //



    const getDetailPanelHeight = React.useCallback(() => 300, []);


    const getTreeDataPath = (contracts) => contracts.hierarchy.split(',');

    const groupingColDef = {
        hideDescendantCount: true,
        width: 330,
    };

    // ****************** BEGIN RETURN ****************************

    return (
<div>
    {submitting && <LinearIndeterminate/>}
        <Box sx={{ height:800 , width: '100%',

            '& .level--1': {backgroundColor: "rgb(30,144,255)"},//https://html-color.codes/blue dodger blue
            '& .level--2': {backgroundColor: "rgb(69,177,232)"},//https://html-color.codes/blue picton blue
            '& .level--3': {backgroundColor: "rgb(135,206,250)"},//https://html-color.codes/blue lightskyblue
            '& .level--4': {backgroundColor: "rgb(137,207,240)"},//https://html-color.codes/blue baby blue
            '& .level--5': {backgroundColor: "rgb(173,216,230)"},//https://html-color.codes/blue light blue
            '& .level--6': {backgroundColor: "rgb(135,206,235)"},//https://html-color.codes/blue skyblue
            '& .level--7': {backgroundColor: "rgb(231,254,255)"},//https://html-color.codes/blue bubbles
            '& .level--8': {backgroundColor: "rgb(244,240,236)"},//https://html-color.codes/grey isabelline
            '& .level--9': {backgroundColor: "rgb(250,250,250)"},//custom
            '& .level--10': {backgroundColor: "rgb(255,255,255)"},//custom
        }}
        >
            <div>
            </div>
            <DataGridPro
                experimentalFeatures={{ newEditingApi: true }}
                sx={{
                    '& .MuiDataGrid-detailPanel': {
                        backgroundColor: deepOrange[100],
                    },
                }}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'hierarchyOrder', sort: 'asc' }],
                    }
                    // filter: {
                    //     items: [
                    //         {
                    //             columnField: 'id',
                    //             operatorValue: '==',
                    //             value: '30'
                    //         }]
                    // }
                }}
                treeData
                aria-label={"Contracts"}
                // components={{ Toolbar: GridToolbar }}
                rows={contracts}
                getRowClassName={(contracts) => `level--${contracts.row.hierarchyLevel}`}
                getDetailPanelContent={({ row }) => (
                    <Box sx={{
                        p: 2, flexGrow: 1,
                        bgcolor: deepOrange[100]
                    }}>
                        <Box sx={{ml: 2}}>
                            <strong>Expression:</strong> {row.expression}
                        </Box>
                        <br/>
                        <Box sx={{ml: 2}}>
                            <strong>Translation:</strong> {row.expressionTranslation}
                        </Box>
                        <br/>
                        <Box sx={{ml: 2}}>
                            <strong>Description:</strong> {row.expressionDescription}
                        </Box>
                        <br/>
                        <Box sx={{ml: 2}}>
                            <strong>Raw Expression:</strong> {row.rawExpression}
                        </Box>
                    </Box>
                )}
                getDetailPanelHeight={getDetailPanelHeight}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={WorkIssuanceOwedGridColumns({
                    hideActions,
                    handleMousedRow,
                    cashState,
                    accrualState,
                    liabilityState,
                    ultimatesState,
                    contracts
                })}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={contract => contract.id}
                getTreeDataPath={getTreeDataPath}
                groupingColDef={groupingColDef}
                components={{
                    // Toolbar: CustomToolbar,
                    // Footer: CustomFooter,
                }}
            />
        </Box>
</div>
    );

    // ****************** END RETURN ****************************

}




